const objContext = JSON.parse(sessionStorage.getItem("context"));
if (objContext == null || objContext.store_name == null)
  location.href = 'index.html';
var id_current_store = null, url_picture = null, objStoreInfo = null;

let reportPanels = document.querySelectorAll('.transactions-table-contains'),
  optionsNav = document.querySelectorAll('.nav-options__item');

let selectTypePay = document.querySelector('#selectTypeTransactions');

let allTransactionsStore = [],
  deliveredOrders = [],
  canceledOrders = [];

let btnExportAllTransactions = document.querySelector('#btnExportAllTransactions');
let csvAllTransactions = ``; // Template - Tabla con todas las transacciones
let csvDeliveryTransactions = ``; // Template - Tabla para el filtro [Entregadas]
let csvCanceledTransactions = ``; // Template - Tabla para filtro [Canceladas]

let filterSelected = 0;

// Indicadores para tablas vacías
let tableAllHaveElements = false
let tableDeliveryHaveElements = false
let tableCanceledHaveElements = false

// Detalles de transacción
let itemsToDetail = [];
let itemsTotalTransaction = ''
let orderTransaction = ''


const sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab');

if (sectionTab != null)
  sectionTab[2].classList.add('sidebar-menu-container-section-tab--active');


document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

window.addEventListener("load", loadPage);
function loadPage() {
  id_current_store = localStorage.getItem("currentStore");
  loadPaymentMethods();
  initSelectDyasTransactions();

  if (id_current_store == null || objContext == null)
    location.href = 'index.html';
  else {
    document.querySelector('.sidebar-profile-img img').src = objContext.store_image
    document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')
    UI.hideLoader();
  }
}


// ------------ Functions -----------------------
function loadPaymentMethods(){
  fetch(BASE_URLS.Dinny.no_cms + '/delivery_payments?store_id=pim-135&req_id=' + new Date().getTime(),
    {
      headers: {
        "Authorization": localStorage.getItem('session')
      },
      method: 'get'
    }
  )
    .then(function (txResponse) {
      if (txResponse.ok) {
        txResponse.json().then(json => {
          json.reduce((acc,item) => {
            item.payment_methods.forEach(i => {
              if(!acc.find(p => p == i.name)){
                acc.push(i.name)
                document.getElementById('selectTypeTransactions').insertAdjacentHTML(
                  'beforeend',
                  `<option value="${i.name}">${i.name}</option>`
                )
              }
            })
            return acc
          }, [])
        })
      } else {
        if (403 == txResponse.status) {
          window.location.href = 'login.html'
        } else {
          alert.error("Ocurrió un error al cargar las transacciones.")
        }
      }
    })
}

/// Cargar tabla con todas las transacciones
function loadAllTransactions(dateStart, dateEnd) {
  UI.showLoader();
  fetch(BASE_URLS.Dinny.api + '/transactions?storeId=' + localStorage.getItem('currentStore') + '&req_id=' + new Date().getTime(),
    {
      credentials: 'include',
      method: 'post'
    }
  )
    .then(function (txResponse) {
      if (txResponse.ok) {
        txResponse.json().then(function (json) {
          allTransactionsStore = [];
          deliveredOrders = [];
          canceledOrders = [];
          // Inicialización de contenedor con reporte de transacciones por filtro para descarga csv
          csvAllTransactions = `data:text/csv;charset=utf-8,Fecha y hora,Orden,Cliente,Forma de pago,Total,Status\r\n`;
          csvDeliveryTransactions = `data:text/csv;charset=utf-8,Fecha y hora,Orden,Cliente,Forma de pago,Total,Status\r\n`;
          csvCanceledTransactions = `data:text/csv;charset=utf-8,Fecha y hora,Orden,Cliente,Forma de pago,Total,Status\r\n`;

          json.forEach((element) => {

            if (element.notification_status == 3 && moment(element.created_at).isBetween(dateStart, dateEnd)) {
              // CREAR TABLA DE ORDENES CANCELADAS
              canceledOrders.push(
                {
                  date: element.created_at,
                  order: element.id,
                  client: element.client.firstName + " " + element.client.lastName,
                  payment: element.payment_method,
                  total: element.total,
                  status: element.notification_status,
                  items: element.items
                }
              );
              //ADD FILTER DATA TO CONTENT CANCELED TRANSACTIONS
              csvCanceledTransactions += `${element.created_at},${element.id},${escape(element.client.firstName + " " + element.client.lastName)},${element.payment_method},${parseFloat(element.total / 100).toFixed(2)},${element.notification_status}\r\n`;
              tableCanceledHaveElements = true
            }
            else {
              if (element.notification_status == 4 && moment(element.created_at).isBetween(dateStart, dateEnd)) {
                // CREAR TABLA DE ORDENES ENTREGADAS
                deliveredOrders.push(
                  {
                    date: element.created_at,
                    order: element.id,
                    client: element.client.firstName + " " + element.client.lastName,
                    payment: element.payment_method,
                    total: element.total,
                    status: element.notification_status,
                    items: element.items
                  }
                );
                //ADD FILTER DATA TO CONTENT DELIVERY TRANSACTIONS
                csvDeliveryTransactions += `${element.created_at},${element.id},${escape(element.client.firstName + " " + element.client.lastName)},${element.payment_method},${parseFloat(element.total / 100).toFixed(2)},${element.notification_status}\r\n`;
                tableDeliveryHaveElements = true
              }
            }
            // todas las transacciones que tengan status cancelado o entregado
            if (element.notification_status == 3 || element.notification_status == 4) {
              if (moment(element.created_at).isBetween(dateStart, dateEnd)) {
                allTransactionsStore.push(
                  {
                    date: element.created_at,
                    order: element.id,
                    client: element.client.firstName + " " + element.client.lastName,
                    payment: element.payment_method,
                    total: element.total,
                    status: element.notification_status,
                    items: element.items
                  }

                );
                //ADD DATA TO ALL TRANSACTIONS CSV
                csvAllTransactions += `${element.created_at},${element.id},${escape(element.client.firstName + " " + element.client.lastName)},${element.payment_method},${parseFloat(element.total / 100).toFixed(2)},${element.notification_status}\r\n`;
                tableAllHaveElements = true
              }
            }
          });

          buildTableAllTransactions(allTransactionsStore);
          buildTableDeliveredTransactions(deliveredOrders);
          buildTableCanceledTransactions(canceledOrders);

          UI.hideLoader();
        })
      } else {
        if (403 == txResponse.status) {
          window.location.href = 'login.html'
        } else {
          alert.error("Ocurrió un error al cargar las transacciones.")
        }
      }
    })
}


//build tables
function buildTableAllTransactions(data) {

  if (data.length == 0) {
    $('#btnExportAllTransactions').addClass('hide');
    document.querySelector('.table-all-container').innerHTML = '<p class="empty-orders">No hay ordenes para mostrar.</p>';
    currentPageSpan.textContent = '0';
    currentPageSpanBottom.textContent = '0';
    allPagesSpan.textContent = 'de 0';
    allPagesSpanBottom.textContent = 'de 0';
    showResultsAllTop.textContent = 'Se muestran 0 de 0';
    showResultsAllBottom.textContent = 'Se muestran 0 de 0';
  }

  else {
    $('#btnExportAllTransactions').removeClass('hide');
    maxPages = Math.ceil(data.length / pageSize);
    if (pageNumber != maxPages) {
      btnNext.disabled = false;
    }
    currentPageSpan.textContent = pageNumber;
    currentPageSpanBottom.textContent = pageNumber;
    allPagesSpan.textContent = 'de ' + maxPages;
    allPagesSpanBottom.textContent = 'de ' + maxPages;
    showResultsAllTop.textContent = data.length <= pageSize ? 'Se muestran ' + data.length + ' de ' + data.length : 'Se muestran ' + pageSize + ' de ' + data.length;
    showResultsAllBottom.textContent = data.length <= pageSize ? 'Se muestran ' + data.length + ' de ' + data.length : 'Se muestran ' + pageSize + ' de ' + data.length;
    data = paginate(data, pageSize, pageNumber);

    document.querySelector('.table-all-container').innerHTML = '';
    let rowLayout = ``;


    data.forEach((element) => {
      let typePayment = "";

      if (element.payment == "cash") {
        typePayment = "Efectivo";
      }
      else {
        typePayment = element.payment;
      }

      if (element.status == 4) {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td>${element.date}</td>
            <td class="td-bold">${element.order}</td>
            <td>${element.client}</td>
            <td>${typePayment}</td>
            <td class="td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right td-small txt-green">Entregada</td>
            <td class="td-right">
              <i class="icon-info enabled mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download enabled" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }

      else {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td class="txt-disabled">${element.date}</td>
            <td class="txt-disabled">${element.order}</td>
            <td class="txt-disabled">${element.client}</td>
            <td class="txt-disabled">${typePayment}</td>
            <td class="txt-disabled td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right td-small txt-red">Cancelada</td>
            <td class="txt-disabled td-right">
              <i class="icon-info disabled mr-05"</i><!--FOR ENABLED ADD onclick="showDetail(event)">-->
              <i class="icon-download disabled"></i><!--FOR ENABLED ADD onclick="exportCSVRow(event)"-->
            </td>
          </tr>
        `;
      }
    });

    let tableLayout = `
    <div class="transactions-table">
      <table>
        <thead>
          <tr>
            <th>Fecha y hora</th>
            <th>Orden</th>
            <th>Cliente</th>
            <th>Forma de pago</th>
            <th class="td-right">Total</th>
            <th class="td-right">Estatus</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
            ${rowLayout}
        </tbody>
      </table>
    </div>
    `;


    document.querySelector('.table-all-container').insertAdjacentHTML('beforeend', tableLayout);
  }

}

function buildTableDeliveredTransactions(data) {
  if (data.length == 0) {
    document.querySelector('.table-delivered-container').innerHTML = '<p class="empty-orders">No hay ordenes entregadas para mostrar.</p>';
    currentPageSpanDelivered.textContent = '0';
    currentPageSpanBottomDelivered.textContent = '0';
    allPagesSpanDelivered.textContent = 'de 0';
    allPagesSpanBottomDelivered.textContent = 'de 0';
    showResultsAllTopDelivered.textContent = 'Se muestran 0 de 0';
    showResultsAllBottomDelivered.textContent = 'Se muestran 0 de 0';
  }

  else {
    maxPagesDelivered = Math.ceil(data.length / pageSizeDelivered);
    if (pageNumberDelivered != maxPagesDelivered) {
      btnNextDelivered.disabled = false;
    }
    currentPageSpanDelivered.textContent = pageNumberDelivered;
    currentPageSpanBottomDelivered.textContent = pageNumberDelivered;
    allPagesSpanDelivered.textContent = 'de ' + maxPagesDelivered;
    allPagesSpanBottomDelivered.textContent = 'de ' + maxPagesDelivered;
    showResultsAllTopDelivered.textContent = data.length <= pageSizeDelivered ? 'Se muestran ' + data.length + ' de ' + data.length : 'Se muestran ' + pageSizeDelivered + ' de ' + data.length;
    showResultsAllBottomDelivered.textContent = data.length <= pageSizeDelivered ? 'Se muestran ' + data.length + ' de ' + data.length : 'Se muestran ' + pageSizeDelivered + ' de ' + data.length;
    data = paginate(data, pageSizeDelivered, pageNumberDelivered);

    document.querySelector('.table-delivered-container').innerHTML = '';
    let rowLayout = ``;


    data.forEach((element) => {
      let typePayment = "";

      if (element.payment == "cash") {
        typePayment = "Efectivo";
      }
      else {
        typePayment = element.payment;
      }

      if (element.status == 4) {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td>${element.date}</td>
            <td class="td-bold">${element.order}</td>
            <td>${element.client}</td>
            <td>${typePayment}</td>
            <td class="td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-green">Entregada</td>
            <td class="td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }

      else {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td class="txt-disabled">${element.date}</td>
            <td class="txt-disabled">${element.order}</td>
            <td class="txt-disabled">${element.client}</td>
            <td class="txt-disabled">${typePayment}</td>
            <td class="txt-disabled td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-red">Cancelada</td>
            <td class="txt-disabled td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }
    });

    let tableLayout = `
    <div class="transactions-table transactions-table-delivered-container">
      <table>
        <thead>
          <tr>
            <th>Fecha y hora</th>
            <th>Orden</th>
            <th>Cliente</th>
            <th>Forma de pago</th>
            <th class="td-right">Total</th>
            <th class="td-right">Estatus</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
            ${rowLayout}
        </tbody>
      </table>
    </div>
    `;


    document.querySelector('.table-delivered-container').insertAdjacentHTML('beforeend', tableLayout);

  }// else end

}

function buildTableCanceledTransactions(data) {
  if (data.length == 0) {
    document.querySelector('.table-canceled-container').innerHTML = '<p class="empty-orders">No hay ordenes canceladas para mostrar.</p>';
    currentPageSpanCanceled.textContent = '0';
    currentPageSpanBottomCanceled.textContent = '0';
    allPagesSpanCanceled.textContent = 'de 0';
    allPagesSpanBottomCanceled.textContent = 'de 0';
    showResultsAllTopCanceled.textContent = 'Se muestran 0 de 0';
    showResultsAllBottomCanceled.textContent = 'Se muestran 0 de 0';
  }

  else {
    maxPagesCanceled = Math.ceil(data.length / pageSizeCanceled);
    if (pageNumberCanceled != maxPagesCanceled) {
      btnNextCanceled.disabled = false;
    }
    currentPageSpanCanceled.textContent = pageNumberCanceled;
    currentPageSpanBottomCanceled.textContent = pageNumberCanceled;
    allPagesSpanCanceled.textContent = 'de ' + maxPagesCanceled;
    allPagesSpanBottomCanceled.textContent = 'de ' + maxPagesCanceled;
    showResultsAllTopCanceled.textContent = data.length <= pageSizeCanceled ? 'Se muestran ' + data.length + ' de ' + data.length : 'Se muestran ' + pageSizeCanceled + ' de ' + data.length;
    showResultsAllBottomCanceled.textContent = data.length <= pageSizeCanceled ? 'Se muestran ' + data.length + ' de ' + data.length : 'Se muestran ' + pageSizeCanceled + ' de ' + data.length;
    data = paginate(data, pageSizeCanceled, pageNumberCanceled);


    document.querySelector('.table-canceled-container').innerHTML = '';
    let rowLayout = ``;


    data.forEach((element) => {
      let typePayment = "";

      if (element.payment == "cash") {
        typePayment = "Efectivo";
      }
      else {
        typePayment = element.payment;
      }

      if (element.status == 4) {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td>${element.date}</td>
            <td class="td-bold">${element.order}</td>
            <td>${element.client}</td>
            <td>${typePayment}</td>
            <td class="td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-green">Entregada</td>
            <td class="td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }

      else {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td class="txt-disabled">${element.date}</td>
            <td class="txt-disabled">${element.order}</td>
            <td class="txt-disabled">${element.client}</td>
            <td class="txt-disabled">${typePayment}</td>
            <td class="txt-disabled td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-red">Cancelada</td>
            <td class="txt-disabled td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }
    });

    let tableLayout = `
    <div class="transactions-table transactions-table-canceled-container">
      <table>
        <thead>
          <tr>
            <th>Fecha y hora</th>
            <th>Orden</th>
            <th>Cliente</th>
            <th>Forma de pago</th>
            <th class="td-right">Total</th>
            <th class="td-right">Estatus</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
            ${rowLayout}
        </tbody>
      </table>
    </div>
    `;


    document.querySelector(`.table-canceled-container`).insertAdjacentHTML('beforeend', tableLayout);
  }

}

function initSelectDyasTransactions() {

  // let dateString = $('#selectDaysTransactions span').text();
  $('#selectTypeTransactions').removeClass('hide');
  $('.transactions-container').removeClass('hide');
  loadAllTransactions(moment(), moment().subtract(6, 'days'));

  cb(moment(), moment().subtract(6, 'days'))

  function cb(start, end) {
    $('#selectDaysTransactions p').html(start.format('YYYY/MM/DD') + ' - ' + end.format('YYYY/MM/DD'));
    loadAllTransactions(start.format('YYYY-MM-DD') + ' 00:00:00', end.format('YYYY-MM-DD') + ' 23:59:59');
  }

  $('#selectDaysTransactions').daterangepicker({
    alwaysShowCalendars: false,
    maxDate: moment(),
    ranges: {
      'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
      'Últimos 15 días': [moment().subtract(14, 'days'), moment()],
      'Últimos 30 días': [moment().subtract(29, 'days'), moment()]
    },
    "locale": {
      "format": "YYYY/MM/DD",
      "separator": " - ",
      "applyLabel": "Seleccionar",
      "cancelLabel": "Cancelar",
      "fromLabel": "desde",
      "toLabel": "hasta",
      "customRangeLabel": "Personalizado",
      "weekLabel": "S",
      "daysOfWeek": [
        "Do",
        "Lu",
        "Ma",
        "Mi",
        "Ju",
        "Vi",
        "Sa"
      ],
      "monthNames": [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
      ],
      "firstDay": 1
    },
  }, cb);

}


// Filtrar datos de tabla a partir de opciòn seleccionada
function showOptionReport(numberOptionPanel) {
  document.querySelector('.nav-options__item-active').classList.remove('nav-options__item-active');
  document.querySelector(`[data-option = "${numberOptionPanel}"]`).classList.add('nav-options__item-active');
  filterSelected = numberOptionPanel;
  reportPanels.forEach((panel) => { panel.classList.add('hide'); });
  reportPanels[numberOptionPanel].classList.remove('hide');

  // Mostrar botón para exportar CSV
  switch(parseInt(filterSelected)){
    case 0:
      if(tableAllHaveElements)
        $('#btnExportAllTransactions').removeClass('hide');
      else
        $('#btnExportAllTransactions').addClass('hide');
      break
    case 1:
      if(tableDeliveryHaveElements)
        $('#btnExportAllTransactions').removeClass('hide');
      else
        $('#btnExportAllTransactions').addClass('hide');
      break
    case 2:
      if(tableCanceledHaveElements)
        $('#btnExportAllTransactions').removeClass('hide');
      else
        $('#btnExportAllTransactions').addClass('hide');
      break
  }
}


function export_csv(e) {
  let encodedUri = '';

  switch(parseInt(filterSelected)){
    case 0:
      encodedUri = (csvAllTransactions);
      break
    case 1:
      encodedUri = (csvDeliveryTransactions);
      break
    case 2:
      encodedUri = (csvCanceledTransactions);
      break
  }

  let link = document.createElement("a")
  link.setAttribute("href", encodedUri)
  link.setAttribute("download", `Transacciones - ${objContext.store_name.replace(/\\/, '')}.csv`)
  link.style = 'display: none'
  document.body.appendChild(link)

  link.click()
  return false
}

function exportCSVDetail() {
  let csvDetail = `data:text/csv;charset=utf-8,Cantidad,Producto,Precio\r\n`;

  itemsToDetail.forEach((item) => {
    csvDetail += `${item.quantity},${escape(item.name)},${parseFloat(item.total_value / 100).toFixed(2)}\r\n`;
  });
  // Agregar el total de los items
  csvDetail += `,Total:,${ itemsTotalTransaction}\r\n`;

  let encodedUri = (csvDetail)
  let link = document.createElement("a")
  link.setAttribute("href", encodedUri)
  link.setAttribute("download", `Orden - ${orderTransaction}.csv`)
  link.style = 'display: none'
  document.body.appendChild(link)

  link.click()
  return false
}

function exportCSVRow(e) {
  let dataRow = e.target.parentNode.parentNode.querySelectorAll('td');
  let csvRow = `data:text/csv;charset=utf-8,Fecha y hora,Orden,Cliente,Forma de pago,Total,Estatus\r\n`;
  csvRow += `${dataRow[0].textContent},${dataRow[1].textContent},${escape(dataRow[2].textContent)},${dataRow[3].textContent},${dataRow[4].textContent},${dataRow[5].textContent}\r\n`;

  let encodedUri = (csvRow)
  let link = document.createElement("a")
  link.setAttribute("href", encodedUri)
  link.setAttribute("download", `Transaccion ${dataRow[1].textContent}.csv`)
  link.style = 'display: none'
  document.body.appendChild(link)

  link.click()
  return false
}

// modal detail
function showDetail(e) {
  let idTransaction = e.target.parentNode.parentNode.dataset.transaction,
    itemsTransaction = [],
    totalTransaction = null,
    layoutItems = ``;

  for (let i = 0; i < allTransactionsStore.length; i++) {
    if (allTransactionsStore[i].order == idTransaction) {
      itemsTransaction = allTransactionsStore[i].items;
      totalTransaction = parseFloat(allTransactionsStore[i].total / 100).toFixed(2);
      break;
    }
  }

  itemsTransaction.forEach((item) => {
    layoutItems += `
      <div class="detail-item">
        <div class="left">
          <div class="quantity">${item.quantity}</div>
          <div class="product">${item.name}</div>
        </div>
        <div class="right">$${parseFloat(item.total_value / 100).toFixed(2)}</div>
      </div>
    `;
  });

  // Guardar en variable global
  itemsToDetail = itemsTransaction;
  itemsTotalTransaction = totalTransaction;
  orderTransaction = idTransaction;


  let layoutDetail = `
    <div>
      <div class="detail-header">
        <div class="left">
          <div class="quantity">Cantidad</div>
          <div class="product">Producto</div>
        </div>
        <div class="right">Precio</div>
      </div>

      ${layoutItems}

      <p class="detail-total">Total: $${totalTransaction}<p>
      <div class="modal-actions">
        <button class="btn btn-solid-primary" id="exportCSVDetail" onclick="exportCSVDetail()">Exportar CSV</button>
      </div>
    </div>
  `;

  UI.detailTransaction({ title: `Orden ${idTransaction}`, content: layoutDetail, accept: 'Aceptar' });
}

// filter type pay method
// all transactions
function buildTableTypePayMethodAllTrans(typePayMethod) {

  if (allTransactionsStore.length == 0) {
    $('#btnExportAllTransactions').addClass('hide');
    document.querySelector('.table-all-container').innerHTML = '<p class="empty-orders">No hay ordenes para mostrar.</p>';
    currentPageSpan.textContent = '0';
    currentPageSpanBottom.textContent = '0';
    allPagesSpan.textContent = 'de 0';
    allPagesSpanBottom.textContent = 'de 0';
    showResultsAllTop.textContent = 'Se muestran 0 de 0';
    showResultsAllBottom.textContent = 'Se muestran 0 de 0';
  }

  else {
    $('#btnExportAllTransactions').removeClass('hide');

    switch (typePayMethod) {
      case "cash":
        let arrayPayCash = [];
        allTransactionsStore.forEach((element) => {
          if (element.payment == "cash") {
            arrayPayCash.push(element);
          }
        });
        buildTablePanel0(arrayPayCash);
        break;

      case "Openpay":
        let arrayPayOpenPay = [];
        allTransactionsStore.forEach((element) => {
          if (element.payment == "Openpay") {
            arrayPayOpenPay.push(element);
          }
        });
        buildTablePanel0(arrayPayOpenPay);
        break;

      case "PayPal":
        let arrayPayPayPal = [];
        allTransactionsStore.forEach((element) => {
          if (element.payment == "PayPal") {
            arrayPayPayPal.push(element);
          }
        });
        buildTablePanel0(arrayPayPayPal);
        break;

      default:
        buildTablePanel0(allTransactionsStore);

    }
  }
}

function buildTablePanel0(data) {

  if (data.length == 0) {
    $('#btnExportAllTransactions').addClass('hide');
    document.querySelector('.table-all-container').innerHTML = '<p class="empty-orders">No hay ordenes para mostrar.</p>';
    currentPageSpan.textContent = '0';
    currentPageSpanBottom.textContent = '0';
    allPagesSpan.textContent = 'de 0';
    allPagesSpanBottom.textContent = 'de 0';
    showResultsAllTop.textContent = 'Se muestran 0 de 0';
    showResultsAllBottom.textContent = 'Se muestran 0 de 0';
  }

  else {
    $('#btnExportAllTransactions').removeClass('hide');
    maxPages = Math.ceil(data.length / pageSize);
    if (pageNumber != maxPages) {
      btnNext.disabled = false;
    }
    currentPageSpan.textContent = pageNumber;
    allPagesSpan.textContent = 'de ' + maxPages;
    data = paginate(data, pageSize, pageNumber);


    document.querySelector('.table-all-container').innerHTML = '';
    let rowLayout = ``;

    data.forEach((element) => {
      let typePayment = "";

      if (element.payment == "cash") {
        typePayment = "Efectivo";
      }
      else {
        typePayment = element.payment;
      }

      if (element.status == 4) {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td>${element.date}</td>
            <td class="td-bold">${element.order}</td>
            <td>${element.client}</td>
            <td>${typePayment}</td>
            <td class="td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-green">Entregada</td>
            <td class="td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }

      else {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td class="txt-disabled">${element.date}</td>
            <td class="txt-disabled">${element.order}</td>
            <td class="txt-disabled">${element.client}</td>
            <td class="txt-disabled">${typePayment}</td>
            <td class="txt-disabled td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-red">Cancelada</td>
            <td class="txt-disabled td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }
    });

    let tableLayout = `
    <div class="transactions-table">
      <table>
        <thead>
          <tr>
            <th>Fecha y hora</th>
            <th>Orden</th>
            <th>Cliente</th>
            <th>Forma de pago</th>
            <th class="td-right">Total</th>
            <th class="td-right">Estatus</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
            ${rowLayout}
        </tbody>
      </table>
    </div>
    `;

    document.querySelector('.table-all-container').insertAdjacentHTML('beforeend', tableLayout);
  }
}

// delivered transactions
function buildTableTypePayMethodDeliveredTrans(typePayMethod) {

  if (deliveredOrders.length == 0) {
    $('#btnExportAllTransactions').addClass('hide');
    document.querySelector('.table-delivered-container').innerHTML = '<p class="empty-orders">No hay ordenes para mostrar.</p>';
    currentPageSpanDelivered.textContent = '0';
    currentPageSpanBottomDelivered.textContent = '0';
    allPagesSpanDelivered.textContent = 'de 0';
    allPagesSpanBottomDelivered.textContent = 'de 0';
    showResultsAllTopDelivered.textContent = 'Se muestran 0 de 0';
    showResultsAllBottomDelivered.textContent = 'Se muestran 0 de 0';
  }

  else {
    $('#btnExportAllTransactions').removeClass('hide');
    switch (typePayMethod) {
      case "cash":
        let arrayPayCash = [];
        deliveredOrders.forEach((element) => {
          if (element.payment == "cash") {
            arrayPayCash.push(element);
          }
        });
        buildTablePanel1(arrayPayCash);
        break;

      case "Openpay":
        let arrayPayOpenPay = [];
        deliveredOrders.forEach((element) => {
          if (element.payment == "Openpay") {
            arrayPayOpenPay.push(element);
          }
        });
        buildTablePanel1(arrayPayOpenPay);
        break;

      case "PayPal":
        let arrayPayPayPal = [];
        deliveredOrders.forEach((element) => {
          if (element.payment == "PayPal") {
            arrayPayPayPal.push(element);
          }
        });
        buildTablePanel1(arrayPayPayPal);
        break;

      default:
        buildTablePanel1(deliveredOrders);

    }
  }
}

function buildTablePanel1(data) {

  if (data.length == 0) {
    $('#btnExportAllTransactions').addClass('hide');
    document.querySelector('.table-delivered-container').innerHTML = '<p class="empty-orders">No hay ordenes para mostrar.</p>';
    currentPageSpanDelivered.textContent = '0';
    currentPageSpanBottomDelivered.textContent = '0';
    allPagesSpanDelivered.textContent = 'de 0';
    allPagesSpanBottomDelivered.textContent = 'de 0';
    showResultsAllTopDelivered.textContent = 'Se muestran 0 de 0';
    showResultsAllBottomDelivered.textContent = 'Se muestran 0 de 0';
  }

  else {
    $('#btnExportAllTransactions').removeClass('hide');
    document.querySelector('.table-delivered-container').innerHTML = '';
    let rowLayout = ``;

    data.forEach((element) => {
      let typePayment = "";

      if (element.payment == "cash") {
        typePayment = "Efectivo";
      }
      else {
        typePayment = element.payment;
      }

      if (element.status == 4) {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td>${element.date}</td>
            <td class="td-bold">${element.order}</td>
            <td>${element.client}</td>
            <td>${typePayment}</td>
            <td class="td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-green">Entregada</td>
            <td class="td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }

      else {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td class="txt-disabled">${element.date}</td>
            <td class="txt-disabled">${element.order}</td>
            <td class="txt-disabled">${element.client}</td>
            <td class="txt-disabled">${typePayment}</td>
            <td class="txt-disabled td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-red">Cancelada</td>
            <td class="txt-disabled td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }
    });

    let tableLayout = `
    <div class="transactions-table">
      <table>
        <thead>
          <tr>
            <th>Fecha y hora</th>
            <th>Orden</th>
            <th>Cliente</th>
            <th>Forma de pago</th>
            <th class="td-right">Total</th>
            <th class="td-right">Estatus</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
            ${rowLayout}
        </tbody>
      </table>
    </div>
    `;

    document.querySelector('.table-delivered-container').insertAdjacentHTML('beforeend', tableLayout);
  }
}

// cancel transactions
function buildTableTypePayMethodCanceledTrans(typePayMethod) {

  if (canceledOrders.length == 0) {
    $('#btnExportAllTransactions').addClass('hide');
    document.querySelector('.table-canceled-container').innerHTML = '<p class="empty-orders">No hay ordenes para mostrar.</p>';
    currentPageSpanCanceled.textContent = '0';
    currentPageSpanBottomCanceled.textContent = '0';
    allPagesSpanCanceled.textContent = 'de 0';
    allPagesSpanBottomCanceled.textContent = 'de 0';
    showResultsAllTopCanceled.textContent = 'Se muestran 0 de 0';
    showResultsAllBottomCanceled.textContent = 'Se muestran 0 de 0';
  }

  else {
    $('#btnExportAllTransactions').removeClass('hide');
    switch (typePayMethod) {
      case "cash":
        let arrayPayCash = [];
        canceledOrders.forEach((element) => {
          if (element.payment == "cash") {
            arrayPayCash.push(element);
          }
        });
        buildTablePanel2(arrayPayCash);
        break;

      case "Openpay":
        let arrayPayOpenPay = [];
        canceledOrders.forEach((element) => {
          if (element.payment == "Openpay") {
            arrayPayOpenPay.push(element);
          }
        });
        buildTablePanel2(arrayPayOpenPay);
        break;

      case "PayPal":
        let arrayPayPayPal = [];
        canceledOrders.forEach((element) => {
          if (element.payment == "PayPal") {
            arrayPayPayPal.push(element);
          }
        });
        buildTablePanel2(arrayPayPayPal);
        break;

      default:
        buildTablePanel2(canceledOrders);

    }
  }
}

function buildTablePanel2(data) {

  if (data.length == 0) {
    $('#btnExportAllTransactions').addClass('hide');
    document.querySelector('.table-canceled-container').innerHTML = '<p class="empty-orders">No hay ordenes para mostrar.</p>';
    currentPageSpanCanceled.textContent = '0';
    currentPageSpanBottomCanceled.textContent = '0';
    allPagesSpanCanceled.textContent = 'de 0';
    allPagesSpanBottomCanceled.textContent = 'de 0';
    showResultsAllTopCanceled.textContent = 'Se muestran 0 de 0';
    showResultsAllBottomCanceled.textContent = 'Se muestran 0 de 0';
  }

  else {
    $('#btnExportAllTransactions').removeClass('hide');
    document.querySelector('.table-canceled-container').innerHTML = '';
    let rowLayout = ``;

    data.forEach((element) => {
      let typePayment = "";

      if (element.payment == "cash") {
        typePayment = "Efectivo";
      }
      else {
        typePayment = element.payment;
      }

      if (element.status == 4) {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td>${element.date}</td>
            <td class="td-bold">${element.order}</td>
            <td>${element.client}</td>
            <td>${typePayment}</td>
            <td class="td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-green">Entregada</td>
            <td class="td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }

      else {
        rowLayout += `
          <tr data-transaction="${element.order}">
            <td class="txt-disabled">${element.date}</td>
            <td class="txt-disabled">${element.order}</td>
            <td class="txt-disabled">${element.client}</td>
            <td class="txt-disabled">${typePayment}</td>
            <td class="txt-disabled td-right">$${parseFloat(element.total / 100).toFixed(2)}</td>
            <td class="td-right txt-red">Cancelada</td>
            <td class="txt-disabled td-right">
              <i class="icon-info mr-05" onclick="showDetail(event)"></i>
              <i class="icon-download" onclick="exportCSVRow(event)"></i>
            </td>
          </tr>
        `;
      }
    });

    let tableLayout = `
    <div class="transactions-table">
      <table>
        <thead>
          <tr>
            <th>Fecha y hora</th>
            <th>Orden</th>
            <th>Cliente</th>
            <th>Forma de pago</th>
            <th class="td-right">Total</th>
            <th class="td-right">Estatus</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
            ${rowLayout}
        </tbody>
      </table>
    </div>
    `;

    document.querySelector('.table-canceled-container').insertAdjacentHTML('beforeend', tableLayout);
  }
}

// event listeners
optionsNav.forEach((option) => {
  option.addEventListener("click", (event) => {
    //console.log('Event', event.target.dataset.option)
    showOptionReport(event.target.dataset.option);
  });
});

btnExportAllTransactions.addEventListener('click', () => {
  export_csv();
});

selectTypePay.addEventListener('change', () => {
  buildTableTypePayMethodAllTrans(selectTypePay.value);
  buildTableTypePayMethodDeliveredTrans(selectTypePay.value);
  buildTableTypePayMethodCanceledTrans(selectTypePay.value);
});


//--- Paginator todas las transacciones
let pageNumber = 1,
  pageSize = 10,
  maxPages = 0,
  currentPageSpan = document.querySelector('#currentPage'),
  currentPageSpanBottom = document.querySelector('#currentPageBottom'),
  allPagesSpan = document.querySelector('#allPages'),
  allPagesSpanBottom = document.querySelector('#allPagesBottom'),
  showResultsAllTop = document.querySelector('#show-results-all-top'),
  showResultsAllBottom = document.querySelector('#show-results-all-bottom'),
  btnNext = document.querySelector('#btnNext'),
  btnPrev = document.querySelector('#btnPrev'),
  btnNextBottom = document.querySelector('#btnNextBottom'),
  btnPrevBottom = document.querySelector('#btnPrevBottom');

// funciones
function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function nextPage() {
  pageNumber++;
  if (pageNumber == maxPages) {
    btnNext.disabled = true;
    btnNextBottom.disabled = true;
  }
  btnPrev.disabled = false;
  btnPrevBottom.disabled = false;

  buildTableAllTransactions(allTransactionsStore);
}

function previusPage() {
  pageNumber--;
  if (pageNumber == 1) {
    btnPrev.disabled = true;
    btnPrevBottom.disabled = true;
  }
  btnNext.disabled = false;
  btnNextBottom.disabled = false;
  buildTableAllTransactions(allTransactionsStore);
}


//-- Paginator
btnPrev.addEventListener("click", previusPage);
btnNext.addEventListener("click", nextPage);
btnPrevBottom.addEventListener("click", previusPage);
btnNextBottom.addEventListener("click", nextPage);


//--- Paginator transacciones entregadas
let pageNumberDelivered = 1,
  pageSizeDelivered = 10,
  maxPagesDelivered = 0,
  currentPageSpanDelivered = document.querySelector('#currentPageDelivered'),
  currentPageSpanBottomDelivered = document.querySelector('#currentPageBottomDelivered'),
  allPagesSpanDelivered = document.querySelector('#allPagesDelivered'),
  allPagesSpanBottomDelivered = document.querySelector('#allPagesBottomDelivered'),
  showResultsAllTopDelivered = document.querySelector('#show-results-delivered-top'),
  showResultsAllBottomDelivered = document.querySelector('#show-results-delivered-bottom'),
  btnNextDelivered = document.querySelector('#btnNextDelivered'),
  btnPrevDelivered = document.querySelector('#btnPrevDelivered'),
  btnNextBottomDelivered = document.querySelector('#btnNextBottomDelivered'),
  btnPrevBottomDelivered = document.querySelector('#btnPrevBottomDelivered');

// funciones

function nextPageDelivered() {
  pageNumberDelivered++;
  if (pageNumberDelivered == maxPagesDelivered) {
    btnNextDelivered.disabled = true;
    btnNextBottomDelivered.disabled = true;
  }
  btnPrevDelivered.disabled = false;
  btnPrevBottomDelivered.disabled = false;

  buildTableDeliveredTransactions(deliveredOrders);
}

function previusPageDelivered() {
  pageNumberDelivered--;
  if (pageNumberDelivered == 1) {
    btnPrevDelivered.disabled = true;
    btnPrevBottomDelivered.disabled = true;
  }
  btnNextDelivered.disabled = false;
  btnNextBottomDelivered.disabled = false;
  buildTableDeliveredTransactions(deliveredOrders);
}


//-- Paginator
btnPrevDelivered.addEventListener("click", previusPageDelivered);
btnNextDelivered.addEventListener("click", nextPageDelivered);
btnPrevBottomDelivered.addEventListener("click", previusPageDelivered);
btnNextBottomDelivered.addEventListener("click", nextPageDelivered);


//--- Paginator transacciones canceladas
let pageNumberCanceled = 1,
  pageSizeCanceled = 10,
  maxPagesCanceled = 0,
  currentPageSpanCanceled = document.querySelector('#currentPageCanceled'),
  currentPageSpanBottomCanceled = document.querySelector('#currentPageBottomCanceled'),
  allPagesSpanCanceled = document.querySelector('#allPagesCanceled'),
  allPagesSpanBottomCanceled = document.querySelector('#allPagesBottomCanceled'),
  showResultsAllTopCanceled = document.querySelector('#show-results-canceled-top'),
  showResultsAllBottomCanceled = document.querySelector('#show-results-canceled-bottom'),
  btnNextCanceled = document.querySelector('#btnNextCanceled'),
  btnPrevCanceled = document.querySelector('#btnPrevCanceled'),
  btnNextBottomCanceled = document.querySelector('#btnNextBottomCanceled'),
  btnPrevBottomCanceled = document.querySelector('#btnPrevBottomCanceled');

// funciones

function nextPageCanceled() {
  pageNumberCanceled++;
  if (pageNumberCanceled == maxPagesCanceled) {
    btnNextCanceled.disabled = true;
    btnNextBottomCanceled.disabled = true;
  }
  btnPrevCanceled.disabled = false;
  btnPrevBottomCanceled.disabled = false;

  buildTableCanceledTransactions(canceledOrders);
}

function previusPageCanceled() {
  pageNumberCanceled--;
  if (pageNumberCanceled == 1) {
    btnPrevCanceled.disabled = true;
    btnPrevBottomCanceled.disabled = true;
  }
  btnNextCanceled.disabled = false;
  btnNextBottomCanceled.disabled = false;
  buildTableCanceledTransactions(canceledOrders);
}


//-- Paginator
btnPrevCanceled.addEventListener("click", previusPageCanceled);
btnNextCanceled.addEventListener("click", nextPageCanceled);
btnPrevBottomCanceled.addEventListener("click", previusPageCanceled);
btnNextBottomCanceled.addEventListener("click", nextPageCanceled);


function resetPaginations() {
  pageNumber = 1,
    pageSize = 10,
    maxPages = 0,
    pageNumberDelivered = 1,
    pageSizeDelivered = 10,
    maxPagesDelivered = 0,
    pageNumberCanceled = 1,
    pageSizeCanceled = 10,
    maxPagesCanceled = 0;
}